import React, { useState, useRef, useEffect } from 'react';
import { uploadImageToS3 } from 'src/components/utilities/utils';
import { useUserActions } from 'src/store/users/actions';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'src/store/reducers/state';
interface IProps {
  memberId: string | undefined;
}
const UploadProfileModal: React.FC<IProps> = ({ memberId }) => {
  const dispatch = useDispatch();
  const userAction = useUserActions(dispatch);
  const [profileUrl, setProfileUrl] = useState<string>('');
  const [selectedFile, setSelectedFile] = useState<any>('');
  const ref = useRef<HTMLButtonElement>(null);
  const { isMemberProfileUpdated } = useSelector((state: RootState) => {
    return {
      isMemberProfileUpdated: state.users.isMemberProfileUpdated
    };
  });

  const handleMemberProfileUpload = async (file: any) => {
    uploadImageToS3(
      file[0],
      `v2/member/uploadprofile?memberId=${memberId}&`,
      setProfileUrl,
      'member'
    );
    setSelectedFile(file[0].name);
  };
  useEffect(() => {
    if (isMemberProfileUpdated) {
      if (ref.current) {
        ref.current.click();
        setSelectedFile('');
      }
    }
  }, [isMemberProfileUpdated]);

  const handleSaveClick = () => {
    if (memberId) {
      const updateData = { memberId, profileUrl };
      userAction.updateMemberProfileRequest(updateData);
    }
    setProfileUrl('');
  };
  return (
    <div>
      <div
        className="modal fade"
        id="uploadMemberModal"
        aria-labelledby="uploadVideoLabel"
        aria-hidden="true">
        <div className="modal-dialog relative w-auto pointer-events-none max-w-xl">
          <div className="modal-content">
            <div className="relative modal-header flex flex-shrink-0 items-center justify-between p-4 rounded-t-md">
              <h5
                className="text-xl font-semibold leading-normal text-center w-full"
                id="uploadVideoLabel">
                Upload Profile
              </h5>
              <button
                ref={ref}
                type="button"
                className="dismiss-btn"
                data-bs-dismiss="modal"
                aria-label="Close"></button>
            </div>
            <div className="modal-body relative py-4 px-10">
              <form>
                <label className="font-semibold">Select Profile:</label>
                <div className={`form-group my-5`}>
                  <div className="input-style p-0 speaker-browse-file flex items-center">
                    <input id="uploadFile" className="pl-2" placeholder={`${selectedFile}`} />
                    <div className="fileUpload btn btn-primary mt-0 ml-auto mr-0 px-1 w-28">
                      <span>Select File</span>
                      <input
                        id="uploadBtn"
                        type="file"
                        className="upload"
                        onChange={(e) => handleMemberProfileUpload(e.target.files)}
                      />
                    </div>
                  </div>
                </div>
              </form>
            </div>

            <div className="modal-footer flex flex-shrink-0 flex-wrap items-center justify-center p-4 pb-6 pt-0 rounded-b-md">
              <button
                disabled={profileUrl === '' ? true : false}
                onClick={handleSaveClick}
                type="button"
                className={`px-6 btn-primary w-auto whitespace-nowrap mr-2 ml-0 mt-0 ${
                  profileUrl === '' ? 'opacity-25' : ''
                }`}>
                Save Changes
              </button>
              <button
                type="button"
                className="mx-0 px-6 btn-primary discard-btn w-auto whitespace-nowrap mt-0"
                data-bs-dismiss="modal">
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UploadProfileModal;
